import _ from "lodash";
import OPERATORS from "../constants/operators";

const operatorMap = {
  [OPERATORS.STARTS_WITH]: (value, str) => {
    return _.startsWith(value, str);
  },
  [OPERATORS.CONTAINS]: (value, str) => _.includes(value, str),
  [OPERATORS.NOT_STARTS_WITH]: (value, str) => {
    return !_.startsWith(value, str);
  },
  [OPERATORS.NOT_INCLUDE]: (value, str) => !_.includes(value, str),
  [OPERATORS.NOT_BLANKS]: (value) => {
    return !!value;
  },
};

const freeTextSearch = (rowValue, operator, string) => {
  return (
    !operatorMap[operator] ||
    operatorMap[operator](
      (rowValue && rowValue.toString().toLowerCase()) || "",
      string.toLowerCase()
    )
  );
};
const textFilterMethod = (filter, rowOrRowValue) => {
  const { operator, string, clearFilter, multiSelectValues } = filter.value;
  if (clearFilter) {
    return true;
  }

  let rowValue;
  if (rowOrRowValue) {
    rowValue = rowOrRowValue.hasOwnProperty(filter.id)
      ? rowOrRowValue[filter.id]
      : rowOrRowValue;
  } else {
    rowValue = "";
  }

  const isRowValueArray = Array.isArray(rowValue);

  if (multiSelectValues && multiSelectValues.length) {
    if (isRowValueArray) {
      return !!_.find(
        multiSelectValues,
        (multiSelectValue) => rowValue.indexOf(multiSelectValue.value) > -1
      );
    }

    return (
      (rowValue === "" &&
        !!_.find(
          multiSelectValues,
          (multiSelectValue) =>
            multiSelectValue.value == null || multiSelectValue.value === ""
        )) ||
      !!_.find(multiSelectValues, { value: rowValue || null })
    );
  }

  if (isRowValueArray) {
    return rowValue.some((value) => freeTextSearch(value, operator, string));
  }

  return freeTextSearch(rowValue, operator, string);
};

export default textFilterMethod;
